import React from 'react';
interface TechnicalGridProps {
  children: React.ReactNode;
  showCoordinates?: boolean;
  className?: string;
}
export function TechnicalGrid({
  children,
  showCoordinates = false,
  className = ''
}: TechnicalGridProps) {
  return <div className={`relative ${className}`} data-id="element-411">
      {/* Grid background */}
      <div className="absolute inset-0 grid-bg opacity-50" data-id="element-412"></div>

      {/* Scan line effect */}
      <div className="absolute inset-0 scan-lines opacity-30" data-id="element-413"></div>

      {/* Animated scan beam */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-414">
        <div className="absolute inset-x-0 h-px bg-gradient-to-r from-transparent via-tech-blue to-transparent opacity-30 animate-scan" data-id="element-415"></div>
      </div>

      {/* Coordinates */}
      {showCoordinates && <>
          <div className="absolute top-4 left-4 font-mono text-xs text-tech-blue opacity-50" data-id="element-416">
            [0,0]
          </div>
          <div className="absolute top-4 right-4 font-mono text-xs text-tech-blue opacity-50" data-id="element-417">
            [100,0]
          </div>
          <div className="absolute bottom-4 left-4 font-mono text-xs text-tech-blue opacity-50" data-id="element-418">
            [0,100]
          </div>
          <div className="absolute bottom-4 right-4 font-mono text-xs text-tech-blue opacity-50" data-id="element-419">
            [100,100]
          </div>
        </>}

      {/* Content */}
      <div className="relative z-10" data-id="element-420">{children}</div>
    </div>;
}